module.exports = __webpack_public_path__ + "static/media/loder_ v.aa65ce0f.gif";